/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Fun_Cow_WishInputs */

const fr_free_fun_cow_wish = /** @type {(inputs: Free_Fun_Cow_WishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer`)
};

/**

* @param {Free_Fun_Cow_WishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const free_fun_cow_wish = /** @type {((inputs?: Free_Fun_Cow_WishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Fun_Cow_WishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_free_fun_cow_wish(inputs)
});